import React from 'react';
import { ResponsiveContainer, BarChart, Bar, Cell, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';

/**
 * "Pont d'inventaire" waterfall: backlog début + reçus − fermés = backlog fin.
 * Implemented with a recharts stacked bar (transparent `base` spacer + visible
 * `bar`) so totals and step deltas line up like a waterfall.
 */
const GPSWaterfallChart = ({ start = 0, received = 0, resolved = 0, end = 0 }) => {
  const afterReceived = start + received;
  const data = [
    { label: 'Ouverts début', base: 0, bar: start, color: '#3a4a63', display: start },
    { label: 'Reçus', base: start, bar: received, color: '#2f6df0', display: `+${received}` },
    { label: 'Fermés', base: Math.min(afterReceived, end), bar: resolved, color: '#16a866', display: `−${resolved}` },
    { label: 'Ouverts fin', base: 0, bar: end, color: '#1b2030', display: end },
  ];

  const renderTooltip = ({ active, payload }) => {
    if (!active || !payload || !payload.length) return null;
    const row = payload[0]?.payload;
    if (!row) return null;
    return (
      <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow px-3 py-2 text-xs">
        <div className="font-semibold text-gray-900 dark:text-white">{row.label}</div>
        <div className="text-gray-500 dark:text-gray-400">{row.display}</div>
      </div>
    );
  };

  return (
    <div>
      <div className="h-72 w-full">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 20, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="label" tickLine={false} axisLine={false} tickMargin={8} style={{ fontSize: '12px' }} />
            <YAxis allowDecimals={false} tickLine={false} axisLine={false} tickMargin={8} style={{ fontSize: '12px' }} />
            <Tooltip content={renderTooltip} cursor={{ fill: 'transparent' }} />
            <Bar dataKey="base" stackId="w" fill="transparent" />
            <Bar dataKey="bar" stackId="w" radius={[5, 5, 0, 0]}>
              {data.map((row, i) => (
                <Cell key={i} fill={row.color} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
      <p className="mt-3 text-xs text-gray-600 dark:text-gray-300 font-medium text-center">
        {start} <span className="text-[#2f6df0]">+ {received} reçus</span>{' '}
        <span className="text-[#16a866]">− {resolved} fermés</span> ={' '}
        <strong className="text-gray-900 dark:text-white">{end} ouverts</strong>
      </p>
    </div>
  );
};

export default GPSWaterfallChart;
